import apiClient from '../connections/api'

export default {
    login: (username, password) => {
        const requestBody = {
            username,
            password
        }
        return apiClient.post('/auth/login', requestBody)
    },
    register: (userData, password) => {
        const requestBody = {
            userData,
            password
        }
        return apiClient.post('/auth/register', requestBody)
    },
    forgotPassword: (email) => {
        const requestBody = {
            email
        }
        return apiClient.post('/auth/forgotpassword', requestBody)
    },
    restorePassword: (password, token) => {
        const requestBody = {
            password
        }
        return apiClient.post(`/auth/resetpassword/${token}`, requestBody)
    },
    logout: (userData) => {
        const requestBody = {
            userData
        }
        return apiClient.post('/auth/logout', requestBody)
    },
    cambiarPassword: (oldPassword, newPassword) => {
        const requestBody = {
            oldPassword,
            newPassword
        }
        return apiClient.post('/auth/changePassword', requestBody)
    },
    requestResetInternal: (rut) => {
        const requestBody = {
            rut
        }
        return apiClient.post('/auth/request-reset-internal', requestBody)
    }
}
